import React, {useEffect, useState} from "react";
import SearchBlog from "./search-blog";
import PropTypes from "prop-types";
import {useRouter} from "next/router";
import Link from "next/link";
import { useTranslation } from "next-i18next";

const MwBlogs = (props) => {
    const router = useRouter()
    const slug = router.query.slug
    const { t } = useTranslation("common");

    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 160 && isScrolled != true) {
                setIsScrolled(true);
            } else if(isScrolled != false) {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className={`blog-hero ${isScrolled ? "active-scroll" : ""}`}>
                <div className={"container"}>
                    <div className={"header-section"}>
                        <div className={"d-flex"}>
                            <div className={"left-block"}>
                                <div className={"category-title"}>{t('blog.hero.categoryTitle')}</div>
                                <h1>{t('blog.hero.heroTitle')}</h1>
                            </div>
                            <div className={"right-block"}>
                                <SearchBlog searchInputPostDetails={props.searchInputPostDetails}/>
                            </div>
                        </div>
                        <div className={"tabNav"}>
                            <ul>
                                <Link href={"/blog/"}><li className={`tab ${slug == undefined ? 'active' : ""}`}><p>{t('blog.tabs.blogs')}</p></li></Link>
                                <Link href={"/blog/category/knowledge/"}><li className={`tab ${slug == 'knowledge' ? 'active' : ""}`}><p>{t('blog.tabs.knowledge')}</p></li></Link>
                                <Link href={"/blog/category/best-practices/"}><li className={`tab ${slug == 'best-practices' ? 'active' : ""}`}><p>{t('blog.tabs.bestPractices')}</p></li></Link>
                                <Link href={"/blog/category/comparison/"}><li className={`tab ${slug == 'comparison' ? 'active' : ""}`}><p>{t('blog.tabs.comparison')}</p></li></Link>
                                <Link href={"/blog/category/engineering/"}><li className={`tab ${slug == 'engineering' ? 'active' : ""}`}><p>{t('blog.tabs.engineering')}</p></li></Link>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

MwBlogs.defaultProps = {
    searchInputPostDetails:[],
}

MwBlogs.propTypes = {
    searchInputPostDetails:PropTypes.array.isRequired,
}

export default MwBlogs